var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFile = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.5 4a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5h13ZM18 5H6v14h12V5Zm-6.5 11a.5.5 0 1 1 0 1h-3a.5.5 0 1 1 0-1h3Zm4-3a.5.5 0 1 1 0 1h-7a.5.5 0 0 1 0-1h7Zm0-3a.5.5 0 1 1 0 1h-7a.5.5 0 0 1 0-1h7Zm0-3a.5.5 0 1 1 0 1h-7a.5.5 0 0 1 0-1h7Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export default ForwardRef;